import React, { memo } from 'react';
import PropTypes from 'prop-types';
import {Grid} from 'HTKit/Grid';
import Faq from 'src/components/Elements/Faq';
import styles from './styles.scss';

const ProductFaq = ({ className, data }) => (
  <section className={styles.container}>
    <Grid.Fluid>
      <Grid.Row>
        <Grid.Column sm={4} md={8} lg={6} lgOffset={3}>
          <Faq items={data} className={className} titleStyle="h4" title="Frequently-Asked Questions"/>
        </Grid.Column>
      </Grid.Row>
    </Grid.Fluid>
  </section>
);

ProductFaq.propTypes = {
  className: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.shape({})),
};

export default memo(ProductFaq);
